import { addItemToCollection } from "directus/src/operations";

export async function createRepo(item) {
  try {
    const response = await addItemToCollection("projects__integrations", item);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function createChannel(item) {
  try {
    const response = await addItemToCollection("projects__integrations", item);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function createFolder(item) {
  try {
    const response = await addItemToCollection("projects__integrations", item);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
